enum RenderPass {
  COLOR = 'color',
  DEPTH = 'depth',
  REFLECT_DEPTH = 'reflect-depth',
  COLOR_MASK = 'color-mask',

  DEFAULT = COLOR,
}

export default RenderPass
